export default {
  appResourceName: 'payments',
  hasuraResourceName: 'invoiceadvance_view_bulk_advance_payment_info',
  fields: [
    {
      app: 'id',
      hasura: 'id',
    },
    {
      app: 'totalEntries',
      hasura: 'amount',
    },
    {
      app: 'bankingTransactionDd',
      hasura: 'banking_transaction_id',
    },
    {
      app: 'completedAt',
      hasura: 'completed_at',
    },
    {
      app: 'concept',
      hasura: 'concept',
    },
    {
      app: 'createdAt',
      hasura: 'created_at',
    },
    {
      app: 'importerName',
      hasura: 'customer',
    },
    {
      app: 'invoiceQty',
      hasura: 'invoice_qty',
    },
    {
      app: 'invoiceAdvanceId',
      hasura: 'invoice_advance_id',
    },
    {
      app: 'requestedAt',
      hasura: 'requested_at',
    },
    {
      app: 'state',
      hasura: 'state',
    },
    {
      app: 'wireConfirmation',
      hasura: 'swift_reference',
    },
    {
      app: 'customerId',
      hasura: 'customer_id',
    },
    {
      app: 'receipt',
      hasura: 'receipt',
    },
  ],
}
